import api from '@/config/axios';

export const catalogApi = {
  settings: () => api.axios.get('/api/catalog').then(r => r.data),
  saveSettings: data => api.axios.put('/api/catalog', data).then(r => r.data),
  availability: (slug, signal) => api.axios.get('/api/catalog/availability', { params: { slug }, signal }).then(r => r.data),
  products: (params, signal) => api.axios.get('/api/catalog/products', { params, signal }).then(r => r.data),
  saveProducts: products => api.axios.put('/api/catalog/products', { products }).then(r => r.data),
  saveCategory: (name, id) => (id ? api.axios.put(`/api/catalog/categories/${id}`, { name }) : api.axios.post('/api/catalog/categories', { name })).then(r => r.data),
  deleteCategory: id => api.axios.delete(`/api/catalog/categories/${id}`).then(r => r.data),
  saveBanners: banners => api.axios.put('/api/catalog/banners', { banners }).then(r => r.data),
  upload: (image, kind) => {
    const data = new FormData();
    data.append('image', image);
    data.append('kind', kind);
    return api.axios.post('/api/catalog/media', data).then(r => r.data);
  },
};

export function catalogError(error) {
  const data = error?.response?.data;
  if (data?.errors) return Object.values(data.errors).flat().join(' ');
  return data?.message || (typeof data === 'string' ? data : '') || error?.message || 'Não foi possível concluir. Tente novamente.';
}

export function normalizeCatalogSlug(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export function catalogUrl(slug) {
  return `${(process.env.VUE_APP_CATALOG_PUBLIC_URL || window.location.origin).replace(/\/$/, '')}/${slug || ''}`;
}

// Fetch deliberately omits credentials, including same-origin cookies. Private axios
// interceptors and visitor authentication must never affect storefront requests.
export async function publicCatalog(path, params = {}, signal) {
  const base = api.axios.defaults.baseURL || window.location.origin;
  const url = new URL(`/api/public/catalogs/${path}`, base);
  Object.entries(params).forEach(([key, value]) => { if (value !== '' && value != null) url.searchParams.set(key, value); });
  const response = await fetch(url, { credentials: 'omit', headers: { Accept: 'application/json' }, signal });
  if (!response.ok) {
    const error = new Error(response.status === 404 ? 'Catálogo indisponível' : 'Não foi possível carregar a loja. Tente novamente.');
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export function money(value) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value || 0));
}

export function whatsappLink(catalog, product) {
  const phone = String(catalog.whatsapp || '').replace(/\D/g, '');
  const text = product
    ? [`Olá, ${catalog.name}! Tenho interesse neste produto:`, '', product.name, product.sku ? `SKU: ${product.sku}` : '',
      `Preço: ${money(product.price)}`, `Link: ${catalogUrl(catalog.slug)}/produto/${product.id}`].filter(Boolean).join('\n')
    : `Olá, ${catalog.name}! Vim pelo catálogo online e gostaria de mais informações.`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}
